import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

const { Types, Creators } = createActions({
  syncTodayOrders: null,
  syncTodayOrdersDisconnected: null,
  setTodayOrders: ['data'],

  syncDriverPendingOrders: null,
  syncDriverPendingOrdersDisconnected: null,
  setDriverPendingOrders: ['data'],

  confirmOrderRequest: null,
  confirmOrderSuccess: ['order'],
  confirmOrderFail: ['error'],

  rejectOrderRequest: null,
  rejectOrderSuccess: ['order'],
  rejectOrderFail: ['error'],
})

export const INITIAL_STATE = Immutable({
  todayOrders: {},
  delivereeInProgressOrders: {},
  delivererInProgressOrders: {},

  todayOrdersLoading: false,
  todayOrdersLoaded: false,
})

export const syncTodayOrdersReducer = state => state.set('todayOrdersLoading', true)

export const setTodayOrdersReducer = (state, { data }) =>
  state
    .set('todayOrders', data.orders)
    .set('delivereeInProgressOrders', data.delivereeInProgressOrders)
    .set('delivererInProgressOrders', data.delivererInProgressOrders)
    .set('todayOrdersLoaded', true)
    .set('todayOrdersLoading', false)

export const syncTodayOrdersDisconnectedReducer = state =>
  state.set('todayOrdersLoaded', false).set('todayOrdersLoading', false)

export const orderReducer = createReducer(INITIAL_STATE, {
  [Types.SYNC_TODAY_ORDERS]: syncTodayOrdersReducer,
  [Types.SET_TODAY_ORDERS]: setTodayOrdersReducer,
  [Types.SYNC_TODAY_ORDERS_DISCONNECTED]: syncTodayOrdersDisconnectedReducer,
})

export const OrderTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js